import { PropsWithChildren } from "react"

import { useApiMutation } from "../../../../../../core/api/useApiMutation"
import { CreateBillReceiverDialogCore } from "../../../../../../shared/components/billReceivers/dialog/CreateBillReceiverDialogCore"
import { fetchAccountingBillReceivers } from "../billReceiversApi"

import { AddBillReceiver } from "../../../organization/userGroups/components/AddBillReceiver"
import { BillReceiversItem } from "../billReceiversTypes"
import {
    BillReceiversFormValuesType,
    BillReceiversType,
    SendInvoiceCompany,
} from "../../../../../../shared/components/billReceivers/billReceiverTypes"

type ConfirmModalProps = Readonly<
    PropsWithChildren<{
        open: boolean
        onClose: () => void
        companyId: number
        title: string
        onSimpleSelect?: (billReceiver: BillReceiversItem) => void
        onSelectBillReceiver: (
            billReceiver:
                | BillReceiversFormValuesType & {
                      type: BillReceiversType | null
                      search?: string
                      companySendInvoice?: SendInvoiceCompany
                  },
        ) => void
    }>
>

export function CreateBillDialog({
    open,
    onClose,
    companyId,
    title,
    onSelectBillReceiver,
    onSimpleSelect,
}: ConfirmModalProps) {
    const { mutateAsync: searchBillReceivers, isLoading: isSearching } = useApiMutation(
        fetchAccountingBillReceivers,
        {},
    )

    return (
        <CreateBillReceiverDialogCore<BillReceiversItem>
            open={open}
            onClose={onClose}
            title={title}
            closeOnSubmit
            onSimpleSelect={onSimpleSelect}
            onSelectBillReceiver={onSelectBillReceiver}
            onSearch={async ({ search }) => {
                const res = await searchBillReceivers({ companyId, search })
                return { exists: Boolean(res.billReceivers?.length) }
            }}
            isSearching={isSearching}
            renderAddBillReceiverDialog={({ open: modalOpen, setOpen, type, searchText, onChoose, onCreateNew }) => (
                <AddBillReceiver
                    type={type}
                    searchText={searchText}
                    companyId={companyId}
                    dialogState={modalOpen}
                    setDialogState={setOpen}
                    handleChooseBillReceiver={onChoose}
                    handleCreateNewBill={onCreateNew}
                />
            )}
        />
    )
}
